import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

export default function ExportFlowModal({ flow, onClose, fetchCode }) {
  const [code, setCode] = useState('');
  const [exporting, setExporting] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      const result = await fetchCode(flow);
      if (!active) return;
      if (result === null) {
        onClose();
        return;
      }
      setCode(result);
      setExporting(false);
    })();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flow]);

  function handleCopy() {
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div className="manage-bots-modal-overlay" onClick={onClose}>
      <div className="manage-bots-modal" style={{ maxWidth: 440 }} onClick={e => e.stopPropagation()}>
        <div className="manage-bots-modal-header">
          <h3>
            <Download size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} />
            Exportar Fluxo
          </h3>
          <button className="manage-bots-close" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
        </div>
        <p className="text-sm text-white/40 mb-4">
          Compartilhe este código para importar o fluxo{' '}
          <strong className="text-white">"{flow.name}"</strong> em outra conta/bot.
        </p>
        <label className="text-xs font-bold text-white/40 uppercase tracking-wider mb-2 block">
          Código de Exportação
        </label>
        <div className="relative">
          {exporting ? (
            <div className="w-full h-20 flex items-center justify-center bg-white/[0.03] border border-white/[0.06] rounded-xl text-white/40 text-sm">
              <i className="fas fa-spinner fa-spin mr-2" /> Gerando código...
            </div>
          ) : (
            <textarea
              readOnly
              className="w-full h-20 bg-white/[0.03] border border-white/[0.06] rounded-xl p-4 text-sm text-white/80 font-mono resize-none focus:outline-none"
              value={code}
            />
          )}
          {code && (
            <button
              className="absolute top-3 right-3 px-3 py-1.5 rounded-lg text-xs font-bold text-white btn-secondary flex items-center gap-1"
              onClick={handleCopy}
            >
              {copied ? <><i className="fas fa-check" /> Copiado!</> : <><i className="fas fa-copy" /> Copiar</>}
            </button>
          )}
        </div>
        <div className="manage-bots-footer" style={{ marginTop: '1rem' }}>
          <div />
          <div className="manage-bots-footer-actions">
            <button className="btn-secondary" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
